import { smTokens } from '../theme/semantic-vars.css.ts';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style, styleVariants } from '../layer.css';

export const drawerOverlay = style({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: '#0202034D',
});

export const drawerContentVariants = styleVariants({
  bottom: {
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: `${borderRadius.r16} ${borderRadius.r16} 0 0`,
  },
  top: {
    left: 0,
    right: 0,
    top: 0,
    borderRadius: `0 0 ${borderRadius.r16} ${borderRadius.r16}`,
  },
  left: {
    left: 0,
    top: 0,
    bottom: 0,
    borderRadius: `0 ${borderRadius.r16} ${borderRadius.r16} 0`,
  },
  right: {
    right: 0,
    top: 0,
    bottom: 0,
    borderRadius: `${borderRadius.r16} 0 0 ${borderRadius.r16}`,
  },
});

export const drawerContent = style({
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: themeVars.container.primary.background.idle,
  outline: 'none',

  selectors: {
    '&[data-inversed]': {
      backgroundColor: themeVars.nav.base,
    },
  },
});

export const drawerContentHandle = style({
  margin: `${space.s16}px auto`,
  height: 4,
  width: 40,
  borderRadius: 9999,
  backgroundColor: themeVars.button.primary.background.idle,

  selectors: {
    '&[data-inversed]': {
      backgroundColor: smTokens.text.inverse,
    },
  },
});

export const drawerHeader = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s4,
    padding: `${space.s10}px ${space.s16}px`,
  },
]);

export const drawerTitle = style([typography.titleLg]);

export const drawerDescription = style([typography.bodyMd]);

export const drawerFooter = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  padding: `${space.s10}px ${space.s16}px ${space.s40}px`,
});
